import React, { useState, useEffect } from 'react'
import Typography from '@material-ui/core/Typography'
import Slider from '@material-ui/core/Slider'
import Grid from '@material-ui/core/Grid'
import { Field } from 'redux-form'
import { makeStyles } from '@material-ui/core/styles'
import { analogRequired } from '../../../../utilties/validators'

const useStyles = makeStyles((theme) => ({
	sliderWrapper: {
		minHeight: '68px',
		margin: '26px 0 0',
		position: 'relative',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'center',
		alignItems: 'center',
		flexWrap: 'nowrap',
		width: '100%',
		marginBottom: '0',
		[theme.breakpoints.down('sm')]: {
			justifyContent: 'space-between',
			flexWrap: 'wrap',
			margin: '0',
			height: 'auto',
			maxWidth: 'calc(100% - 8px)'
		},
	},
	errorWrapper: {
		position: 'absolute', 
		bottom: '-17px',
		left: '0',
		[theme.breakpoints.down('sm')]: {
			bottom: 'auto',
			position: 'relative',
			marginTop: '12px'
		},
	},
	leftInfo: {
		width: 'auto',
		display: 'flex',
		flexDirection: 'column-reverse',
		justifyContent: 'left',
		maxWidth: '25%',
		[theme.breakpoints.down('sm')]: {
			flex: '0 0 50%',
			order: '1',
		}
	},
	slider: {
		minWidth: '150px',
		flexGrow: '100',
		width: '50%',
		flexBasis: '100%',
		[theme.breakpoints.down('sm')]: {
			order: '3',
			flex: '100%',
			minWidth: '70px',
			width: '100%',
			padding: '0 8px',
			'& .MuiSlider-root': {
				padding: '26px 0 13px 0',
				marginBottom: '0'
			}
		},
	},
	rightInfo: {
		width: 'auto',		
		justifyContent: 'right',
		textAlign: 'right',
		maxWidth: '25%',
		[theme.breakpoints.down('sm')]: {
			order: '2',
			flex: '0 0 50%',
		}
	},

	leftLabel: {
		fontWeight: '400',
		[theme.breakpoints.down('sm')]: {
			fontSize: '11px'
		},
	},
	leftImageWrap: {
		width: '100%',
	},
	leftImage: {
		maxHeight: '32px',
		maxWidth: '32px',
		[theme.breakpoints.down('sm')]: {
			maxHeight: '16px',
			maxWidth: '16px',
		},
	},

	rightImageWrap: {
		width: '100%',
	},
	rightImage: {
		maxHeight: '32px',
		maxWidth: '32px',
		[theme.breakpoints.down('sm')]: {
			maxHeight: '16px',
			maxWidth: '16px',
		},
	},
	rightLabelWrap: {
		[theme.breakpoints.down('sm')]: {
			textAlign: 'right'
		},
	},
	rightLabel: {
		fontWeight: '400',
		[theme.breakpoints.down('sm')]: {
			fontSize: '11px'
		},
	},
	hiddenThumb: {
		opacity: '0'
	},
	focusedThumb: {
		opacity: '1'
	},
	valueLabel: {
		fontSize: '14px',
		[theme.breakpoints.down('sm')]: {
			fontSize: '11px',
			left: 'calc(-50% + 2px)',
    		top: '-13px',
			'& > span': {
				width: '20px',
				height: '20px'
			}
		},		
	},
	mark: {
		height: '4px'
	},
	markActive: {
		backgroundColor: 'steelblue'
	},
	markLabel: {
		fontSize: '14px',
		color: 'gray',
		[theme.breakpoints.down('sm')]: {
			fontSize: '11px'
		},
	}
}))

const requiredValidator = analogRequired

const SliderField = ({
	input,
	label,
	meta: { touched, error, form, dispatch },
	children,
	question,
	disabled,
	...custom
}) => {
	const classes = useStyles()
	const [sliderValue, setSliderValue] = useState(null)
	const [marks, setMarks] = useState(undefined)


	useEffect(
		() => {
			setSliderValue(input.value)
		},
		[input.value]
	)

	useEffect(
		() => {
			let inc = question.stepValue.toString().match(/\.(\d+)/)?.pop().length
			if (!inc) {
				inc = 1
			}
			else {
				inc = parseInt('1' + String().padStart(inc, '0'))
			}
			const q = {
				startValue: question.startValue * inc,
			  endValue: question.endValue * inc,
			  stepValue: question.stepValue * inc
			}
	  
			const maxSteps = 10
			const step = Math.ceil(Math.ceil((q.endValue - q.startValue) / maxSteps) / q.stepValue) * q.stepValue
      		const arrayLength = Math.floor((q.endValue - q.startValue) / step) + 1
			setMarks(
				(!question.hideNumericDisplay && question.stepValue)
					? Array.from( { length: arrayLength },
							(_, index) => {
								let mark = parseFloat(((q.startValue + step * index) / inc).toFixed(2))
								if (mark > (q.endValue / inc))
									mark = (q.endValue / inc)
								return {
									value: mark,
									label: mark
								}
							}
						)
					: undefined
			)
		},
		[question]
	)


	const handleChange = (_, newValue) => {
		setSliderValue(newValue)
	}

	const handleChangeCommited = (_, newValue) => {
		input.onChange(newValue)
	}

	return (
		<Grid data-testid="writable-form-analog-slider-wrap">
			<Grid item>
				<Slider
					data-testid="writable-form-analog-slider"
					disabled={disabled}
					min={question.startValue}
					max={question.endValue}
					step={question.stepValue}
					marks={marks}
					valueLabelDisplay={question.hideNumericDisplay ? "off" : "on"}
					errorText={touched && error}
					{...input}
					{...custom}
					value={sliderValue}
					onChange={handleChange}
					onChangeCommitted={handleChangeCommited}
					classes={{
						thumb: input.value || input.value === 0 ? null : classes.hiddenThumb,
						valueLabel: classes.valueLabel,
						mark: classes.mark,
						markActive: classes.markActive,
						markLabel: classes.markLabel
					}}
				/>
			</Grid>
			<Grid item>
				{touched &&
				error && (
					<span
						data-testid="writable-form-analog-slider-error"
						className={`${classes.errorWrapper} errorWrapper`}	
					>
						{error}
					</span>
				)}
			</Grid>
		</Grid>
	)
}

export default ({
	question,
	disabled,
	inputName
}) => {
	const name = inputName ?? `answers.analog._${question.uniqueId}`

	const classes = useStyles()
	const [ value, setValue ] = React.useState(0)

	let validators = question.isOptional ? null : requiredValidator


	return (
		<Grid data-testid="form-analog-question" style={{ paddingTop: '16px', paddingBottom: '16px' }}>
			<Grid container spacing={2} className={`${classes.sliderWrapper} sliderWrapper`}>
				<Grid container spacing={0} className={classes.leftInfo}>
					{question.startText && (
						<Grid item className={classes.leftLabelWrap}>
							<Typography variant='subtitle2' className={classes.leftLabel}>
								{question.startText}
							</Typography>
						</Grid>
					)}
					{question.startImagePath && (
						<Grid itemclassName={classes.leftImageWrap}>
							<img alt="Start Image Path" src={question.startImagePath} className={classes.leftImage}/>
						</Grid>
					)}
				</Grid>
				{
					question.startValue != null
					&& question.endValue != null
					&& <Grid item xs className={classes.slider}>
						<Field
							data-testid="analog-answer"
							name={name}
							disabled={disabled}
							component={SliderField}
							value={value}
							question={question}
							validate={validators}
						/>
					</Grid>
				}

				<Grid container spacing={0} className={classes.rightInfo}>
					{question.endImagePath && (
						<Grid item className={classes.rightImageWrap}>
							<img alt="End Image Path" src={question.endImagePath} className={classes.rightImage} />
						</Grid>
					)}
					{question.endText && (
						<Grid item className={classes.rightLabelWrap}>
							<Typography variant='subtitle2' className={classes.rightLabel}>
								{question.endText}
							</Typography>
						</Grid>
					)}
				</Grid>
			</Grid>
		</Grid>
	)
}
